<template>
  <div>
    <label for="description">Attachments</label>
    <div
      v-for="attach in list"
      :key="attach.Id"
    >
      <span>{{ attach.Headline }}</span>
      <span
        class="iconButton text-info"
        @click="editAttachment(attach)"
      >
        <i class="bi bi-pencil-square" />
      </span>
      <span
        class="iconButton text-danger"
        @click="deleteConfirm(attach)"
      >
        <i class="bi bi-x-square-fill" />
      </span>
    </div>
    <span
      class="iconButton text-success"
      :class="{ 'iconButton-disabled': disableAdd }"
      @click="addAttachment()"
    >
      <i class="bi bi-plus-square-fill" />
    </span>
    <modal
      :show.sync="showEditAttachment"
      class="modal-primary"
      :show-close="false"
      header-classes="justify-content-center"
      type="mini"
    >
      <div
        slot="header"
        class="ml-4"
      >
        <h6>
          <i class="fa fa-edit mr-2" /><span class="text-danger">{{ editItem.Id ? "Edit" : "Add" }} Attachment</span>
        </h6>
      </div>
      <ValidationObserver ref="form">
        <form
          @submit.prevent="saveAttachment"
          id="theForm"
        >
          <ValidationProvider
            name="title"
            rules="required|max:255"
            v-slot="{ passed, failed }"
          >
            <fg-input
              name="title"
              :error="failed ? 'Title is required': null"
              :has-success="passed"
              required
              label="Title"
              placeholder=""
              max-length="255"
              v-model="editItem.Headline"
            />
          </ValidationProvider>
          <el-input
            v-model="editItemFileName"
            disabled
          >
            <p-button
              size="sm"
              slot="append"
              @click="captureTheUrl"
              class="m-0"
            >
              Upload / Link
            </p-button>
          </el-input>
        </form>
      </ValidationObserver>
      <template slot="footer">
        <p-button
          type="danger"
          class="mr-2"
          @click="cancelDialog"
        >
          Cancel
        </p-button>
        <p-button
          type="success"
          native-type="submit"
          form="theForm"
          class="mr-2"
        >
          Save
        </p-button>
      </template>
    </modal>
    <capture-file
      :is-photo="false"
      ref="captureFile"
      @url-captured="onCapturedUrl"
    />
  </div>
</template>

<script>
import CaptureFile from '@/components/storage/capture-file.vue'
import Modal from '@/plugins/paper-components/modal.vue'
import { Input } from 'element-ui'
import linksApi from '@/services/api/links'

export default {
  name: 'AnnouncementAttachments',
  components: {
    CaptureFile,
    Modal,
    [Input.name]: Input
  },
  props: {
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
    announcementId: {
      type: Number,
      default: null
    }
  },
  data: function () {
    return {
      editItem: {
        FileName: null,
        LinkUrl: null
      },
      showEditAttachment: false,
      editItemFileName: ''
    }
  },
  computed: {
    disableAdd: function () {
      return this.announcementId === undefined || this.announcementId === null || this.announcementId === 0
    }
  },
  methods: {
    setEditItemFileName: function () {
      this.editItemFileName = this.editItem.FileName ? this.editItem.FileName : this.editItem.LinkUrl
    },
    editAttachment: function (attachment) {
      this.editItem = attachment
      this.showEditAttachment = true
    },
    deleteConfirm: function (attachment) {
      const msg = 'Are you sure you want to delete ' + attachment.Headline + '?'
      this.$confirm(msg, 'Are you sure?')
        .then(() => {
          this.deleteAttachment(attachment)
        })
    },
    deleteAttachment: function (attachment) {
      linksApi.delete(this.$root.courseKey, attachment.Id)
        .then(x => {
          this.$emit('attachmentsChanged')
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error deleting the attachment.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(z => {
        })
    },
    addAttachment: function () {
      if (!this.disableAdd) {
        this.editItem = {
          AnnouncementId: this.announcementId,
          CourseKey: this.$root.courseKey
        }
        this.showEditAttachment = true
      }
    },
    saveAttachment: function () {
      return this.$refs.form.validate().then(res => {
        linksApi.update(this.$root.courseKey, this.editItem)
          .then(x => {
            this.$emit('attachmentsChanged')
          })
          .catch(error => {
            console.log(error)
            this.$notify({
              message: 'There was an updating attachments.',
              icon: 'bi bi-exclamation-circle-fill',
              type: 'error',
              horizontalAlign: 'center',
              timeout: 2000
            })
            this.errormessage = error
          })
          .finally(z => {
            this.showEditAttachment = false
          })
        return res
      })
    },
    cancelDialog: function () {
      this.showEditAttachment = false
      this.$nextTick(function () {
        this.$emit('dialogClosed')
      })
    },
    captureTheUrl: function (event) {
      this.$refs.captureFile.showDialog(this.editItem.LinkUrl)
    },
    onCapturedUrl: function (url, fileName) {
      this.editItem.LinkUrl = url
      this.editItem.FileName = fileName
      this.setEditItemFileName()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iconButton {
  padding-left:4px;
  cursor:pointer;
}
.iconButton-disabled {
  cursor:not-allowed !important;
  opacity: 0.3;
}
</style>
